// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeleton fidele du TableauDeBord : la structure reutilise .tableau (style herite),
   on ne style ici que les briques shimmer dans les cellules. */
.table-skeleton .tskel {
  display: block;
  height: 1.4rem;
  width: 80%;
  border-radius: 6px;
  background-color: #e6e8eb;
  background-image: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.65),
    transparent
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: -150% 0;
  animation: tskel-shimmer 1.4s ease-in-out infinite;
}
@keyframes tskel-shimmer {
  to {
    background-position: 150% 0;
  }
}

/* Lignes non cliquables + largeurs variees par colonne pour un rendu naturel. */
.table-skeleton .table-skel-row {
  cursor: default;
}
.table-skeleton td:first-child .tskel {
  width: 55%;
}
.table-skeleton td:nth-child(2) .tskel {
  width: 90%;
}
.table-skeleton td:last-child .tskel {
  width: 45%;
}
`, "",{"version":3,"sources":["webpack://./src/composants/Skeleton/TableSkeleton.css"],"names":[],"mappings":"AAAA;+DAC+D;AAC/D;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB;;;;;GAKC;EACD,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,kDAAkD;AACpD;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,gFAAgF;AAChF;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ","sourcesContent":["/* Skeleton fidele du TableauDeBord : la structure reutilise .tableau (style herite),\n   on ne style ici que les briques shimmer dans les cellules. */\n.table-skeleton .tskel {\n  display: block;\n  height: 1.4rem;\n  width: 80%;\n  border-radius: 6px;\n  background-color: #e6e8eb;\n  background-image: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.65),\n    transparent\n  );\n  background-size: 200% 100%;\n  background-repeat: no-repeat;\n  background-position: -150% 0;\n  animation: tskel-shimmer 1.4s ease-in-out infinite;\n}\n@keyframes tskel-shimmer {\n  to {\n    background-position: 150% 0;\n  }\n}\n\n/* Lignes non cliquables + largeurs variees par colonne pour un rendu naturel. */\n.table-skeleton .table-skel-row {\n  cursor: default;\n}\n.table-skeleton td:first-child .tskel {\n  width: 55%;\n}\n.table-skeleton td:nth-child(2) .tskel {\n  width: 90%;\n}\n.table-skeleton td:last-child .tskel {\n  width: 45%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
